import { render, staticRenderFns } from "./myIdea.vue?vue&type=template&id=d1bc3dfc"
import script from "./myIdea.vue?vue&type=script&lang=js"
export * from "./myIdea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports